<template>
  <main class="container mx-auto">
    <blog-section class="mt-3"/>
  </main>
</template>

<script>
import BlogSection from '../components/section/blogs/BlogSection'

export default {
  name: 'Blog',
  components: { BlogSection },
  metaInfo () {
    return {
      title: this.$t('blog_page.page_title'),
      titleTemplate: null,
      htmlAttrs: {
        lang: this.$i18n.locale, amp: true
      },
      meta: [
        {
          name: 'description',
          content: 'here are my blogs.'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
